import { render, staticRenderFns } from "./liveops-whitepaper.vue?vue&type=template&id=3b8199cc&scoped=true&"
import script from "./liveops-whitepaper.vue?vue&type=script&lang=ts&"
export * from "./liveops-whitepaper.vue?vue&type=script&lang=ts&"
import style0 from "./liveops-whitepaper.vue?vue&type=style&index=0&id=3b8199cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8199cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogAcfBlocks: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/blog/BlogAcfBlocks.vue').default})
